import { register, find } from '../../../../Javascript/Sysmex/Utils'

const Toggle = el => {
  const componentPrefix = el.dataset.componentprefix
  const uncheckedEndpoint = el.dataset.uncheckedendpoint
  const checkedEndpoint = el.dataset.checkedendpoint
  const ajax = el.dataset.ajax
  const input = find(`.${componentPrefix}toggleField`, el)
  const ajaxActiveClass = `${componentPrefix}ajaxActive`
  const submitOnChange = el.dataset.submitonchange

  if (!submitOnChange && !checkedEndpoint && !uncheckedEndpoint) {
    return false
  }

  input.addEventListener('change', () => {
    if (submitOnChange) {
      input.form.requestSubmit()
    }

    if (checkedEndpoint && input.checked) {
      if (ajax) {
        input.classList.add(ajaxActiveClass)
        window.fetch(checkedEndpoint, {
          method: 'POST',
          credentials: 'include'
        }).then(response => {
          input.classList.remove(ajaxActiveClass)
        })
      } else {
        window.location.href = checkedEndpoint
      }
    }

    if (uncheckedEndpoint && !input.checked) {
      if (ajax) {
        input.classList.add(ajaxActiveClass)
        window.fetch(uncheckedEndpoint, {
          method: 'POST',
          credentials: 'include'
        }).then(response => {
          input.classList.remove(ajaxActiveClass)
        })
      } else {
        window.location.href = uncheckedEndpoint
      }
    }
  })
}
register('Toggle', Toggle)
